import React, { useState } from 'react';
import { formatDateIntoDDMMYY, formatToUS, isNotValidNullUndefile } from '../../control/Constant';


const PaymentForm = ({setPaymentData,paymentData,installmentpay,PaymentOption,showSplitpayment,paymentDateDisable,setSplitPaymentno, handleBeforeOpen,paymentFrom,queryData}) => {
   const paymentMethods = ['cash', 'check', 'credit', 'ACH'];
   let isClient = JSON.parse(sessionStorage.getItem('isClient'));
  //  const [splitPaymentno, setSplitPaymentno] = useState(0);

  const handleInputChange = (field, value) => {
    setPaymentData({
      ...paymentData,
      [field]: value
    });
    if(field == 'paymentMethod' && value != 'credit' && ( paymentFrom!= undefined && paymentFrom!= "Agingoptions" )){
      setSplitPaymentno('No')
    }
  };

  // const handleSplitpaymentNumberFunc = (e) => {
  //   console.log(paymentData,"paymentDatapaymentData",e)
  //   let splitAmount = paymentData?.amount / e;
  //   if(e > 4){
  //     alert('Cards number should not be more than 4')
  //     return;
  //   }
  //   let resultArr = []
  //   for (let i = 0; i < e; i++) {
  //     resultArr.push({id: i+1, value: splitAmount})
  //   }
  //   setSplitPaymentno(resultArr)
  // }

  const radioButton = (label, value, state, setState) => {
  // console.log(value,"valuevaluevaluevalue")
  return <label class="radio-label custom-radio">
    <input type="radio" name={label} value={value} checked={state == value} onChange={(e) => setState(e.target.value)} />
    {/* <div class="w-4 h-4 rounded-full border-2 border-gray-400 peer-checked:border-blue-600 peer-checked:bg-blue-600 transition"></div> */}
    <span class="ml-2 text-gray-700">{label}</span>
  </label>
}

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <h3 className="text-lg font-semibold mb-4">{installmentpay == 2 && PaymentOption == 2 ? 'Installment' : 'Payment'} Method<span className="text-red-600">*</span></h3>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        {/* {paymentMethods.filter((ele)=>isClient == true ? ele !== 'cash' : paymentData?.payAmount == 0 ? (ele == 'cash' || ele == 'credit')  :  ele).map(method => (
          <div
            key={method}
            onClick={() => handleInputChange('paymentMethod', method)}
            className={`p-3 border rounded-md cursor-pointer text-center capitalize ${
              paymentData?.paymentMethod === method
                ? 'bg-blue-100 border-blue-500'
                : 'bg-gray-50 border-gray-300'
            }`}
          >
            {method}
          </div>
        ))} */}
        {paymentMethods?.filter((ele) => {
          if (isClient == true) {
            // If it's a client, exclude 'cash'
            return ele !== 'cash';
          } else if (PaymentOption ==  2 && paymentData?.payAmount == 0 && isNotValidNullUndefile(paymentData?.payAmount)) {
            // If payAmount is 0, allow only 'cash' or 'credit'
            return ele === 'cash' || ele === 'credit';
          } else {
            // Otherwise, allow all methods
            return true;
          }
        })?.map((method) => (
            <div
              key={method}
              onClick={() => {handleBeforeOpen(); handleInputChange('paymentMethod', method)}}
              className={`p-3 border rounded-md cursor-pointer text-center capitalize ${paymentData?.paymentMethod === method
                  ? 'bg-blue-100 border-blue-500'
                  : 'bg-gray-50 border-gray-300'
                }`}
            >
              {method}
            </div>
          ))}





      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {installmentpay == 2 && PaymentOption == 2 ? '' : <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Payment Date
          </label>
          <input
            type="date"
            className={`w-full px-3 py-2 border border-gray-300 rounded-md ${(paymentData?.paymentMethod == 'credit' || paymentDateDisable == true || !isNotValidNullUndefile(paymentData?.paymentMethod)) ? 'bg-gray-200 cursor-not-allowed' : ''}`}
            value={paymentData?.paymentDate}
            onChange={(e) => handleInputChange('paymentDate', e.target.value)}
            disabled={(paymentData?.paymentMethod == 'credit' || paymentDateDisable == true || !isNotValidNullUndefile(paymentData?.paymentMethod))  ? true : false}
            // min={new Date().toISOString().split('T')[0]}
            lang="en-US"
          />
        </div>}

        {/* Add specific payment method details here */}
        {paymentData?.paymentMethod === 'check' && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Check Number
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Enter check number"
              value={paymentData?.checkNumber || ''}
              onChange={(e) => handleInputChange('checkNumber', e.target.value)}
            />
          </div>
        )}
        {paymentData?.paymentMethod == 'check' && <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Check Date
          </label>
          <input
            type="date"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            value={paymentData?.checkDate}
            onChange={(e) => handleInputChange('checkDate', e.target.value)}
            lang="en-US"
          />
        </div>}
        {paymentData?.paymentMethod == 'ACH' && <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Account Name</label>
            <input type='text' className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Enter account name" onChange={(e)=> handleInputChange('accountName',e.target.value)}  />
          </div>}
        {paymentData?.paymentMethod == 'ACH' && <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Account Number</label>
            <input type='text' className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Enter account number" onChange={(e)=> handleInputChange('accountNumber',e.target.value)}  />
          </div>}
        {paymentData?.paymentMethod == 'ACH' && <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Routing Number</label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Enter routing number" onChange={(e)=> handleInputChange('routingNumber',e.target.value)} />
          </div>}
        {(paymentData?.paymentMethod == 'ACH' || paymentData?.paymentMethod == 'check') && <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Bank Name</label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Enter bank name" onChange={(e)=> handleInputChange('bankName',e.target.value)} />
          </div>}
        {isNotValidNullUndefile(queryData) && queryData?.paymnetFromEventCoordinator == 'true' && (
          <div className="col-md-12">
            <div className="row" style={{ display: "flex", justifyContent: "space-between" }}>
              {/* Date */}
              <div className="col-4 pe-1">
                <label className="form-label block text-sm font-medium text-gray-700 mb-1">Booking Date</label>
                <input type="date"className="form-control w-full px-3 py-2 border border-gray-300 rounded-md" style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
                  defaultValue={queryData?.registerData?.date} disabled/>
              </div>
              {/* Time */}
              <div className="col-4 ps-1">
                <label className="form-label block text-sm font-medium text-gray-700 mb-1">Booking Time</label>
                <input type="time" className="form-control w-full px-3 py-2 border border-gray-300 rounded-md"style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
                  defaultValue={queryData?.registerData?.time} disabled/>
              </div>
              <div className="col-4 ps-1">
                <label className="form-label block text-sm font-medium text-gray-700 mb-1">Booking Duration</label>
                <input type="text" className="form-control w-full px-3 py-2 border border-gray-300 rounded-md"style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
                  defaultValue={`${queryData?.registerData?.duration} min`} disabled/>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* {showSplitpayment && paymentData?.paymentMethod == 'credit' && <div className="mt-2">
        <h4>Split Payment:</h4>
        <p className="mt-1">Would you like to pay using multiple cards?</p>
        <div className="relative flex gap-3 mt-1">
        {radioButton('Yes','Yes',splitPaymentno,setSplitPaymentno)}
        {radioButton('No','No',splitPaymentno,setSplitPaymentno)}
        </div>
        {splitPaymentno == 'Yes' && (
          <div className="d-flex gap-2">{'Split Amount'}: &nbsp;
          <input type="text" className="w-1/3 px-3 py-2 border border-gray-300 rounded-md mt-2" placeholder='$0' onChange={(e)=>handleInputChange('splitAmount', e.target.value)} value={formatToUS(paymentData?.splitAmount || '')}  />
          </div>
        )}
        </div>} */}
    </div>
  );
}

export default PaymentForm





